export default __webpack_public_path__ + "static/media/webchat-active.830864a7.svg";